import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormService } from '../form.service';

declare var $:any;

@Component({
  selector: 'circular-slider',
  templateUrl: './circular-slider.component.html'
})
export class CircularSliderComponent implements OnInit {

  @Output() emitRange:any = new EventEmitter();
  @Input() cancelIntro;

  @ViewChild('sliderElement') sliderElement;

  animationNames = {
    happy    : 'pulse',
    positive : 'tada',
    neutral  : 'headShake',
    negative : 'headShake',
    sad      : 'jello'
  }

  stepValue = 100 / 6;
  stepLabel:any = false;
  stepImage:any = false;
  sliderReference:any;

  stepRanges = {
    5 : 'Zwaar teleurgesteld',
    4 : 'Nou, het kan beter',
    3 : 'Mwah, gaat wel',
    2 : 'Tevreden!',
    1 : 'Wauw, geweldig',
    0 : 'Maak een keuze'
  };

  constructor(
    private form : FormService
  ) { }

  ngOnInit() {
    this.setupSlider();
  }

  ngOnChanges(changes:any) {
    if (changes['cancelIntro'] && changes['cancelIntro']['currentValue'] == false) {
      this.resetSlider();
    }
  }

  handleEvent(event:any = null) {
    console.log(event);
    let range = Math.round(event.value / this.stepValue);
    this.stepLabel = this.stepRanges[range];
    if (range == 6) range = 0;
    if (range > 0 && range < 6) {
      this.stepImage = range;
    } else {
      this.stepImage = false;
    }
    this.emitRange.emit(range);

  }

  setupSlider() {

    let radius = 150;
    if (window.innerWidth < 321) {
      radius = 120;
    }

    let self   = this;
    this.sliderReference = $("#slider");
    this.sliderReference.roundSlider({

      sliderType: "min-range",
      handleShape: "round",
      width: "30",
      radius: radius,
      value: 0,
      handleSize: "+16",
      startAngle: 270,
      step: self.stepValue,

      drag : function(args) {
        self.handleEvent(args);
      },

      change : function(args) {
        self.handleEvent(args);
      }

    });

    this.triggerDemo();

  }

  timeout1:any = null;
  timeout2:any = null;
  timeout3:any = null;

  triggerDemo() {
    this.timeout1 = setTimeout(() => {
      this.sliderReference.roundSlider('setValue', this.stepValue);
      this.handleEvent({
        value : this.stepValue
      });
    }, 900);
    this.timeout2 = setTimeout(() => {
      this.sliderReference.roundSlider('setValue', this.stepValue * 2);
      this.handleEvent({
        value : this.stepValue * 2
      });
    }, 2900);
    this.timeout3 = setTimeout(() => {
      this.sliderReference.roundSlider('setValue', 0);
      this.handleEvent({
        value : 0
      });
    }, 4900);
  }

  resetSlider() {
    clearTimeout(this.timeout1);
    clearTimeout(this.timeout2);
    clearTimeout(this.timeout3);
    console.log(this.form.selectedRange);
    setTimeout(() => {

      this.handleEvent({
        value : this.stepValue * this.form.selectedRange
      });
      this.sliderReference.roundSlider('setValue', this.stepValue * this.form.selectedRange);
    }, 100);

  }

}



// WEBPACK FOOTER //
// L:/Vodafone/Happy Check/dev/vodhappycheck/src/app/circular-slider/circular-slider.component.ts